import { defaultUseQueryRefetchOptions } from '@/_shared/constants'
import { trpc } from '@/utils/trpc'

export const useBrandStats = (brandId: string) => {
  const { data: brandStatData } = trpc.getBrandStats.useQuery(
    { brandId },
    {
      trpc: {
        context: {
          batch: true,
        },
      },
      ...defaultUseQueryRefetchOptions,
    },
  )

  return {
    brandStatData,
  }
}
